export const adminRouteNames = {
  adminDashboard: 'admin-dashboard',
  refunds: 'admin-refunds',
  organizationSettings: 'organization-settings',
  userSettings: 'user-settings',
  eventSettings: 'admin-event-settings',
  monthlyReport: 'monthly-report',
  ticketInsuranceReport: 'ticket-insurance-report',
  organizationReport: 'organization-report',
  organizerPayouts: 'organizer-payouts',
  ticketSellerPayouts: 'ticket-seller-payouts',
}
